// extracted by mini-css-extract-plugin
export var icon = "index-module--icon--a6a06";
export var wrapper = "index-module--wrapper--fc956";